/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type { PromiseOrValue } from "../../../../../../../../common";
import type {
  ERC721,
  ERC721Interface,
} from "../../../../../../../../contracts/submodules/moar-locker/submodules/moar/contracts/erc/ERC721";

const _abi = [
  {
    inputs: [],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [],
    name: "ApprovalToOwner",
    type: "error",
  },
  {
    inputs: [],
    name: "NonERC721ReceiverImplementer",
    type: "error",
  },
  {
    inputs: [],
    name: "NonExistentToken",
    type: "error",
  },
  {
    inputs: [],
    name: "NonOwner",
    type: "error",
  },
  {
    inputs: [],
    name: "NonOwnerOrApproved",
    type: "error",
  },
  {
    inputs: [],
    name: "NonOwnerOrOperator",
    type: "error",
  },
  {
    inputs: [],
    name: "ZeroAddress",
    type: "error",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "approved",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Approval",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "ApprovalForAll",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Transfer",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "approve",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "getApproved",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
    ],
    name: "isApprovedForAll",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "ownerOf",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "_data",
        type: "bytes",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "setApprovalForAll",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "tokenURI",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "transferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

type ERC721ConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: ERC721ConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class ERC721__factory extends ContractFactory {
  constructor(...args: ERC721ConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override deploy(
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): Promise<ERC721> {
    return super.deploy(overrides || {}) as Promise<ERC721>;
  }
  override getDeployTransaction(
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  override attach(address: string): ERC721 {
    return super.attach(address) as ERC721;
  }
  override connect(signer: Signer): ERC721__factory {
    return super.connect(signer) as ERC721__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): ERC721Interface {
    return new utils.Interface(_abi) as ERC721Interface;
  }
  static connect(address: string, signerOrProvider: Signer | Provider): ERC721 {
    return new Contract(address, _abi, signerOrProvider) as ERC721;
  }
}
